<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();

	// The AccountIcon figure with a crossed-out badge in the bottom-right corner.
	// The badge is knocked out of the figure with a mask so the two never touch,
	// whatever colour the icon is drawn in. The id must be unique per instance:
	// the same icon renders in both the mobile and desktop menus.
	const maskId = $props.id();
</script>

<SvgWrapper {title} {...rest}>
	<defs>
		<mask id={maskId}>
			<rect width="24" height="24" fill="white" />
			<circle cx="18.9" cy="18.9" r="5.65" fill="black" />
		</mask>
	</defs>
	<g mask={`url(#${maskId})`}>
		<!-- Nested: a transform on the masked element itself would drag the cut-out with the figure. -->
		<g transform="translate(0 -0.6)">
			<path
				d="M12.0006 12.6314C14.7198 12.6314 16.9322 10.471 16.9322 7.81569C16.9322 5.16043 14.7198 3 12.0006 3C9.28144 3 7.06901 5.16043 7.06901 7.81569C7.06901 10.471 9.28144 12.6314 12.0006 12.6314ZM12.0006 4.44898C13.9022 4.44898 15.4483 5.95882 15.4483 7.81569C15.4483 9.67256 13.9022 11.1824 12.0006 11.1824C10.099 11.1824 8.55286 9.67256 8.55286 7.81569C8.55286 5.95882 10.0998 4.44898 12.0006 4.44898Z"
				fill={getTailwindColor(color)}
			/>
			<path
				d="M3.54478 20.9739C3.93949 21.079 4.34829 20.8537 4.45735 20.4675C5.38699 17.1674 8.48899 14.8628 11.9998 14.8628C15.5106 14.8628 18.6118 17.1674 19.5422 20.4675C19.6335 20.7892 19.9317 21 20.2574 21C20.3227 21 20.3888 20.9913 20.4548 20.9739C20.8495 20.8674 21.0817 20.4689 20.9734 20.0828C19.8664 16.156 16.1768 13.4139 12.0005 13.4139C7.82422 13.4139 4.13387 16.156 3.02692 20.0828C2.91786 20.4682 3.15008 20.8674 3.54478 20.9739Z"
				fill={getTailwindColor(color)}
			/>
		</g>
	</g>
	<circle
		cx="18.9"
		cy="18.9"
		r="4.4"
		fill="none"
		stroke={getTailwindColor(color)}
		stroke-width="1.4"
	/>
	<path
		d="M16.8 16.8L21 21M21 16.8L16.8 21"
		stroke={getTailwindColor(color)}
		stroke-width="1.4"
		stroke-linecap="round"
	/>
</SvgWrapper>
